import React, { useState, useEffect } from "react";
import classes from "./ReviewModal.module.css";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { Button } from "../../../../stories/Button/Button";
import ModalSkeleton from "../../../ModalSkeleton/ModalSkeleton";
import { ReviewsWithRating } from "../../../../stories/ReviewsOnSidebar/ReviewsOnSidebar";
import modalClasses from "../../../ModalSkeleton/ModalSkeleton.module.css";
import { CheckGreen } from "../../../../constant/imagePath";
import { ReactSVG } from "react-svg";
import Ratings from "react-star-ratings";

export const ReviewModal = ({ show, setShow, profileReviewData }) => {
  const { data } = profileReviewData;
  const { totalRating, rating, reviewsTypes } = profileReviewData.review;

  return (
    <>
      <style>{`
              @media screen and (max-width: 580px) {
            .modal .modal-dialog {
              width: 90% !important;
              margin: 0px 10%;
            }
        }
        .${modalClasses.header}{
            margin:24px;
        }
        .${modalClasses.body}{
            padding:0px 24px;
        }

      `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        headerStyles={{
          marginBottom: "0px",
          paddingBottom: "24px",
        }}
        borderRadius={"20px"}
        width={"328px"}
        header={
          <div>
            <h3
              style={{
                ...Fonts.h3,
                color: Colors.neutralShadesOfNero,
                fontSize: "24px",
                lineHeight: "32px",
              }}
              className={[classes.mb12].join(" ")}
            >
              Your Rating
            </h3>
            <div className={[classes.itemend, classes.dflex].join(" ")}>
              <Ratings
                numberOfStars={1}
                starRatedColor={Colors.mainShadeOfRed}
                starEmptyColor={Colors.neutralShadesOfGainsboro}
                rating={rating / 5}
                starDimension={"20px"}
                starSpacing={"4px"}
              />
              <p
                className={[classes.ml8].join(" ")}
                style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
              >
                ({totalRating} rating)
              </p>
            </div>
          </div>
        }
      >
        <div className={[classes.mb24].join(" ")}>
          <div
            className={[classes.pb24, classes.progressdiv, classes.mb24].join(
              " "
            )}
          >
            {reviewsTypes?.map((item) => {
              return (
                <ReviewsWithRating
                  title={item?.title}
                  rating={item?.rating}
                  progress={item?.progress}
                />
              );
            })}
          </div>
          <div>
            <h6
              className={[classes.mb16].join(" ")}
              style={{ ...Fonts.h6, color: Colors.neutralShadesOfNero }}
            >
              Here’s what your students say about you
            </h6>
            <div className={[classes.tagsdiv].join(" ")}>
              {data?.studentsSayings?.map((item) => {
                return (
                  <span>
                    <Button
                      label={item}
                      customStyle={{
                        ...Fonts.p2,
                        padding: "8px 16px 8px 16px",
                        width: "max-content",
                      }}
                    />
                  </span>
                );
              })}
            </div>
          </div>
        </div>
      </ModalSkeleton>
    </>
  );
};
